import { useState } from 'react';
import type { FAQItem } from '@/types';

interface FAQSectionProps {
  faqItems: FAQItem[];
}

export default function FAQSection({ faqItems }: FAQSectionProps) {
  const [openId, setOpenId] = useState<number | null>(null);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            关于虚空韩漫网的常见疑问解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenId(openId === item.id ? null : item.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">
                  {item.question}
                </span>
                <span className={`w-5 h-5 flex items-center justify-center transition-transform duration-300 flex-shrink-0 ${
                  openId === item.id ? 'rotate-180' : ''
                }`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === item.id ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqItems.map((item) => ({
                '@type': 'Question',
                name: item.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: item.answer,
                },
              })),
            }),
          }}
        />
      </div>
    </section>
  );
}